import { Component } from '@angular/core';

@Component({
  selector: 'busqueda-tesoro-nivel',
  templateUrl: 'busqueda-tesoro-nivel.html'
})
export class BusquedaTesoroNivelComponent {

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/busqueda-tesoro-nivel/busqueda-tesoro-nivel.ts